/**
 * Popin JS
 * Change state on the .Menu when popin is open (z-index)
 * ---> Use jQuery
 */

;(function popin($) {

    $(document).ready(init);

    var CONTAINER_CLASS = '.Menu';
    var ACTIONS_CLASS = '.Menu-actions';
    var BTN_CLASS = '.js-State-btn';


    function init() {
        var container = $(CONTAINER_CLASS);
        var actions = $(ACTIONS_CLASS);

        if (container.length > 0) {
            actions.on('click', BTN_CLASS, changeState);
        }
    }

    function changeState() {
        var container = $(CONTAINER_CLASS);

        if (container.attr('data-state') === 'active') {
            container.attr('data-state', 'inactive');
        } else {
            container.attr('data-state', 'active');
        }
    }

})(jQuery);
